var _path, _path2, _path3, _path4, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkVisits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4398 4.97461H5.75984C4.70384 4.97461 3.84944 5.75299 3.84944 6.70434L3.83984 20.5422C3.83984 21.4935 4.69424 22.2719 5.75024 22.2719H17.2798C18.3358 22.2719 19.1998 21.4935 19.1998 20.5422V10.1638L13.4398 4.97461ZM17.2798 20.5422H5.75984V6.70434H12.4798V11.0287H17.2798V20.5422Z",
    fill: "#5073B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5197 11.8926H7.67969V13.2764H11.5197V11.8926Z",
    fill: "#5073B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67969 18.8115H15.3597V17.4277H7.67969V18.8115Z",
    fill: "#5073B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67969 16.0439H15.3597V14.6601H7.67969V16.0439Z",
    fill: "#5073B9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6327_285377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 15,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.0996,
    y: 0.5,
    width: 13.4,
    height: 11.973,
    fill: "#D9D9D9",
    stroke: "#2196F3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6327_285377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3994 11.8928V12.8928H11.3994H16.1994H16.3994H17.1994H17.3994H22.1994H23.1994V11.8928V8.10906V7.10906H22.1994H21.3994V5.9469V4.9469H20.3994H20.1994V4.86581V1.08203V0.0820312H19.1994H14.3994H13.3994V1.08203V4.86581V4.9469H13.1994H12.1994V5.9469V7.10906H11.3994H10.3994V8.10906V11.8928Z",
    fill: "#2196F3",
    stroke: "white",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkVisits);
export default __webpack_public_path__ + "static/media/bookmark_visits.5b15536113f3ba5424f83704ea1e242c.svg";
export { ForwardRef as ReactComponent };